import fileUploadIcon from '../../../assets/images/icons/featured-file-icon-blue.svg';
import { returnFileSize } from '../../account/components/avatar/avatarSectionHelpers';

type Props = {
  downloadAttachment: any;
  url: string;
  size: number;
  title?: string;
};

const AttachmentCard = ({ downloadAttachment, url, size, title }: Props) => {
  return (
    <div
      className='custom__upload-modal-file-container'
      onClick={() => downloadAttachment(url)}
      onKeyDown={(e) => e.key === 'Enter' && downloadAttachment(url)}
      role='button'
      tabIndex={-2}
    >
      <div className='d-flex' style={{ maxWidth: '90%' }}>
        <img src={fileUploadIcon} alt='attachment icon' />
        <div
          className='ps-2'
          style={{
            height: 'fit-content',
            overflow: 'hidden',
          }}
        >
          <p className='text-gray-700 text-truncate custom__upload-attachments-title' title={url}>
            {title ||
              url.substring(url.lastIndexOf('/') + 1, url.lastIndexOf('?')).replace('%', ' ')}
          </p>
          <p className='text-gray-500 custom__upload-attachments-title'>{returnFileSize(size)}</p>
        </div>
      </div>
    </div>
  );
};

export default AttachmentCard;
